export default "__VITE_ASSET__w0MoYiAV__"